import React, { Fragment, useState } from 'react';
import { OverlayView, Marker } from '@react-google-maps/api';

import { useSelector } from 'react-redux';
import { eventDetailViewSelector } from '../../../features/events/eventsSlice';

import GoogleEventDetailCard from './GoogleEventDetailCard';


const EventMarker = () => {
    const eventDetailView = useSelector(eventDetailViewSelector);
    const eventData = useSelector(state => state.events.eventContent[`${eventDetailView}`]);
    let icon = `/assets/history/def30/event.png`;
    const [showLabel, setshowLabel] = useState(true);
    const onMarkerClick = (e) => {
        setshowLabel(!showLabel);
    }
    if (eventDetailView && eventData && window.google) {
        const lat = parseFloat(eventData.lat);
        const lng = parseFloat(eventData.lng);

        return (
            <Fragment>
                <Marker
                    icon={icon}
                    position={{ lat, lng }}
                    onClick={onMarkerClick}
                />
                <OverlayView
                    position={{ lat, lng }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    {
                        showLabel ?
                            <GoogleEventDetailCard eventData={eventData} />
                            :
                            <p>""</p>
                    }

                </OverlayView>
            </Fragment>
        );
    } else {
        return null;
    }

}

export default React.memo(EventMarker);